// detect firefox, for small adjustments to text positioning to account for different font rendering 
if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1)
{
     $("html").addClass("firefox");
}

// detect internet explorer, for small adjustments to text positioning to account for different font rendering 
if(window.ActiveXObject || "ActiveXObject" in window) {
	$("html").addClass("iexplorer");
}